import React, { Fragment } from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import AgentCard from "./AgentCard";
import Pagination from "../common/Pagination";
import { parse } from "querystring";

import type { $Agents, $Pagination } from "flow/types";

type Props = {
  classes: Object,
  className: string,
  agents: $Agents,
  pagination: $Pagination,
  isSearching: boolean,
  handleSearch: (null | Event, Object) => void,
};

const AgentGrid = ({
  classes,
  className,
  agents,
  pagination,
  location,
  path,
  handleSearch,
  isSearching,
}: Props) => {
  if (!(agents && agents.length > 0)) {
    return (
      <div className={classNames(classes.root, className)}>
        There are no agents to display at this time.
      </div>
    );
  }
  return (
    <Fragment>
      <div className={classNames(classes.root, className)}>
        <div
          className={classNames(
            classes.agents,
            isSearching ? classes.loading : null
          )}
        >
          {agents.map((agent) => (
            <AgentCard className={classes.card} agent={agent} key={agent.id} />
          ))}
        </div>
      </div>
      <div className={classes.paginationContainer}>
        <Pagination
          path={path}
          pagination={pagination}
          handleSearch={handleSearch}
          query={
            location && location.search
              ? parse(location.search.replace("?", ""))
              : {}
          }
        />
      </div>
    </Fragment>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "1184px",
    margin: "48px auto 0px auto",
  },
  loading: {
    position: "absolute",
    height: "100%",
    width: "100%",
    backgroundColor: "#000",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    zIndex: theme.zIndex["loading"],
    opacity: 0.4,
  },
  title: {
    color: theme.colors.gray["800"],
    fontSize: "18px",
    lineHeight: "1",
    fontWeight: "600",
    textTransform: "uppercase",
    textAlign: "center",
    marginBottom: theme.spacing.unit * 0.25,
  },
  agents: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "stretch",
    width: "100%",
  },
  card: {
    margin: "12px 8px",
  },
  topRight: {
    display: "flex",
    justifyContent: "center",

    "&> * + *": {
      marginLeft: theme.spacing.unit * 0.5,
    },
  },
  paginationContainer: {
    backgroundColor: "#fff",
    marginTop: "24px",
    padding: "12px 0px",
  },
}))(AgentGrid);
